import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompanyListRefresh {
  private _refresh  = new Subject<string>();

  public refresh$ = this._refresh.asObservable();

  refresh() {
    this._refresh.next('refresh');
  }
}
